import { Injectable } from '@angular/core';

import { RootState } from '@next/core-lib/app';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';

import * as settingActions from '../store/actions/settings.actions';

@Injectable()
export class SettingsDosatorSettingResolver {
  constructor(private readonly store: Store<RootState>) {}

  resolve() {
    // (Re)Load when on /settings/dosator-setting
    this.store.dispatch(settingActions.loadDosatorSettingsRequest());

    return of(true);
  }
}
